module.exports = __webpack_public_path__ + "img/Prancheta_1.1.3.f97de7c6.png";